import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { LangProvider } from "@/i18n";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const Layout = ({ lang }) => (
  <LangProvider value={lang}>
    <div className="App" data-testid="app-root">
      <ScrollToTop />
      <Header />
      <main className="pt-20 min-h-[70vh]">
        <Outlet />
      </main>
      <Footer />
    </div>
  </LangProvider>
);
